import React from "react";
import { getParam, switchTitleQueryStringAdvanced } from "../../search/api/filterUrlMaker";
import { Form, Col } from "react-bootstrap";
import { _t } from "../../../app/i18n/i18n";
import { useDispatch, useSelector } from "react-redux";
import { searchBarSlice } from "../../../redux/slices/searchBarSlice";

export const Keywords = () => {
  const dispatch = useDispatch();
  const isTitleOnly = useSelector((state) => state.searchbar.isTitleOnly);
  const handleClick = (isTitleOnly) => {
    dispatch(searchBarSlice.actions.setTitleOnly(isTitleOnly));
    switchTitleQueryStringAdvanced(isTitleOnly);
  };
  return (
    <section>
      <div className="bg-light">
        <Form.Group as={Form.Row} controlId="allwords" className="mb-1">
          <Form.Label column sm="2" className="pb-0">
            {_t("With all the words")}
          </Form.Label>
          <Col sm="5">
            <Form.Control
              size="sm"
              placeholder="Keywords here"
              name="allwords"
              autoComplete="off"
              datainputtype="text"
              datafield={isTitleOnly ? "title" : ""}
              defaultValue={getParam("") || getParam("title") || ""}
            />
          </Col>
          <Col sm="5">
            <Form.Text className="text-muted">{_t("Matching reports contain ALL words")}</Form.Text>
          </Col>
        </Form.Group>

        <Form.Group as={Form.Row} controlId="phrase" className="mb-1">
          <Form.Label column sm="2" className="pb-0">
            {_t("With the exact phrase")}
          </Form.Label>
          <Col sm="5">
            <Form.Control
              size="sm"
              placeholder="Phrase here"
              datainputtype="text"
              autoComplete="off"
              datafield={isTitleOnly ? "titleExact" : "exact"}
              defaultValue={getParam("exact") || getParam("titleExact") || ""}
            />
          </Col>
          <Col sm="5">
            <Form.Text className="text-muted">{_t("Matching reports contain the exact phrase")}</Form.Text>
          </Col>
        </Form.Group>

        <Form.Group as={Form.Row} controlId="atleastoneword" className="mb-1">
          <Form.Label column sm="2" className="pb-0">
            {_t("At least one of the words")}
          </Form.Label>
          <Col sm="5">
            <Form.Control
              size="sm"
              placeholder="Keywords here"
              autoComplete="off"
              datainputtype="text"
              datafield={isTitleOnly ? "titleAtleast" : "atleast"}
              defaultValue={getParam("atleast") || getParam("titleAtleast") || ""}
            />
          </Col>
          <Col sm="5">
            <Form.Text className="text-muted">{_t("Matching reports contain one or more of the words")}</Form.Text>
          </Col>
        </Form.Group>

        <Form.Group as={Form.Row} controlId="withoutwords" className="mb-1">
          <Form.Label column sm="2" className="pb-0">
            {_t("Without the words")}
          </Form.Label>
          <Col sm="5">
            <Form.Control
              size="sm"
              placeholder="Words to exclude here"
              datainputtype="text"
              autoComplete="off"
              datafield={isTitleOnly ? "titleExclude" : "exclude"}
              defaultValue={getParam("exclude") || getParam("titleExclude") || ""}
            />
          </Col>
          <Col sm="5">
            <Form.Text className="text-muted">{_t("Matching reports do not contain any of the words")}</Form.Text>
          </Col>
        </Form.Group>
      </div>

      <Form.Group as={Form.Row} controlId="searchwithinfields" className="my-2">
        <Form.Label column sm="2" className="pb-0">
          {_t("Search within") + ":"}
        </Form.Label>
        <Col sm="3">
          <Form.Check
            type="radio"
            label={_t("All report fields")}
            name="searchwithinfields"
            id="allreportfields"
            defaultChecked={!isTitleOnly}
            inline
            onClick={() => handleClick(0)}
          />
          <Form.Check
            type="radio"
            label={_t("Titles only")}
            name="searchwithinfields"
            id="titles-only"
            defaultChecked={isTitleOnly}
            inline
            onClick={() => handleClick(1)}
          />
          <Form.Text className="text-muted">{_t("Search within only the report title or the full report")}</Form.Text>
        </Col>
        <Col sm="6">
          <Form.Check
            type="checkbox"
            disabled
            label={_t("Read reports")}
            id="reports-i-read"
            defaultChecked={true}
            inline
          />
          <Form.Check
            type="checkbox"
            disabled
            label={_t("Unread reports")}
            id="reports-i-havent-read"
            defaultChecked={true}
            inline
          />
          <Form.Check
            type="checkbox"
            disabled
            label={_t("Favourite reports")}
            id="favourite-reports"
            defaultChecked={true}
            inline
          />
          <Form.Text className="text-muted">{_t("Select which reports to search within")}</Form.Text>
        </Col>
      </Form.Group>
    </section>
  );
};
